<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-select v-model="queryCon.devModelId" placeholder="设备型号" clearable style="width: 240px">
                    <el-option v-for="item in deviceModels" :key="item.id" :label="item.devModel + ' ' + item.devName" :value="item.id" />
                </el-select>
                <el-input v-model="queryCon.devNo" placeholder="设备号" style="width: 200px" />
                <el-input v-model="queryCon.devBatchNo" placeholder="批次号" style="width: 160px" />
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="handler.reset">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                    <el-button type="success" plain :icon="UploadFilled" @click="handler.openImportHandler">导入</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }" ref="dataTableRef">
        <el-table-column type="selection" width="40" />
        <el-table-column prop="devNo" label="设备号" width="160" />
        <el-table-column prop="devName" label="设备名称" width="160" />
        <el-table-column prop="devModel" label="设备型号" width="130" />
        <el-table-column prop="devBatchNo" label="批次号" width="130" />
  
        <el-table-column prop="devOnlineStatus" label="在线状态" width="100">
            <template #default="scope">
                <el-tag v-if="scope.row.devOnlineStatus === 0" type="danger">离线</el-tag>
                <el-tag v-else type="success">在线</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="devStatusTime" label="上/下线时间" width="160" />
        <el-table-column prop="devStatusReceiveTime" label="接收时间" width="160" />
        <el-table-column prop="devStatus" label="设备状态" width="100">
            <template #default="scope">
                <el-tag v-if="scope.row.devStatus === 0" type="danger">未使用</el-tag>
                <el-tag v-else-if="scope.row.devStatus === 1" type="success">使用中</el-tag>
                <el-tag v-else type="info">维修中</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="150" />
        <el-table-column prop="iccid" label="IMEI" width="150" />
        <el-table-column prop="modifyName" label="修改人" width="100" />
        <el-table-column prop="modifyDate" label="修改日期" width="180">
            <template #default="scope">
                <span>{{
                    utils.formatDate(scope.row.modifyDate, "YYYY-MM-DD HH:mm:ss")
                }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="110" header-align="center" fixed="right">
            <template #default="scope">
                <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
            </template>
        </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

    <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="800">
        <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
            ref="dataFormRef">
            <el-form-item v-show="false" label="id" prop="id">
                <el-input v-model="form.id"></el-input>
            </el-form-item>
            <el-form-item label="设备号" prop="devNo">
                <el-input v-model="form.devNo" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="设备型号" prop="devModelId">
                <el-select v-model="form.devModelId" placeholder="请选择型号" class="el-input-width">
                    <el-option v-for="item in deviceModels" :key="item.devModel" :label="item.devModel"
                        :value="item.id">
                        <span style="float: left; font-size: 13px; margin-right: 20px">{{
                            item.devModel
                        }}</span>
                        <span style="
                float: right;
                color: var(--el-text-color-secondary);
                font-size: 12px;
              ">
                            {{ item.devName }} | {{ item.devTypeName }} |
                            {{ item.supplierName }}
                        </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="批次号" prop="devBatchNo">
                <el-input v-model="form.devBatchNo" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="ICCID" prop="iccid">
                <el-input v-model="form.iccid" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="IMEI" prop="imei">
                <el-input v-model="form.imei" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="设备状态" prop="devStatus">
                <el-select v-model="form.devStatus" placeholder="请选择状态" class="el-input-width">
                    <el-option label="未使用" :value="0" />
                    <el-option label="使用中" :value="1" />
                    <el-option label="维修中" :value="2" />
                </el-select>
            </el-form-item>

            <el-form-item label="在线状态" prop="devOnlineStatus">
                <el-select v-model="form.devOnlineStatus" placeholder="请选择状态" class="el-input-width">
                    <el-option label="离线" :value="0" />
                    <el-option label="在线" :value="1" />
                </el-select>
            </el-form-item>

            <el-form-item label="所属机构" prop="orgId">
                <el-tree-select v-model="form.orgId" value-key="id" placeholder="所属机构" class="el-input-width"
                    :data="OrgOptions" default-expand-all highlight-current :loading="loading" :props="defaultProps"
                    check-strictly="true" />
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width: 580px" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="handler.saveHandler">保存</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog v-model="importDialogVisible" title="批量导入设备" width="560">
        <el-form :model="importForm" label-width="90px">
            <el-form-item label="设备型号" required>
                <el-select v-model="importForm.devModelId" placeholder="请选择型号" style="width: 100%">
                    <el-option v-for="item in deviceModels" :key="item.id" :label="item.devModel + ' ' + item.devName" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="批次号" required>
                <el-input v-model="importForm.devBatchNo" placeholder="请输入批次号" />
            </el-form-item>
            <el-form-item label="文件" required>
                <el-upload ref="uploadRef" drag :auto-upload="false" :limit="1" accept=".xlsx,.xls"
                    :on-change="handler.onImportFileChange" :on-remove="handler.onImportFileRemove">
                    <el-icon><UploadFilled /></el-icon>
                    <div class="el-upload__text">拖拽文件到此处，或<em>点击上传</em></div>
                    <template #tip>
                        <div class="el-upload__tip">仅支持 .xlsx/.xls 格式，第一列序号、第二列设备号</div>
                    </template>
                </el-upload>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="importDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handler.importHandler">导入</el-button>
            </div>
        </template>
    </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import "../../../src/assets/styles/common.css";
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from "vue";
import { ElTable, ElMessageBox, ElMessage, ElSelect, ElOption } from "element-plus";
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight, UploadFilled } from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import "@/assets/styles/crud-page.css";
import utils from "@/utils/utils";
import { sprintf } from "sprintf-js";
import { deviceApi, deviceModelApi, } from "@/api/deviceApi.js";
//import {deviceModelApi} from '@/services/modules/devices/deviceModelApi.js';
import { orgApi } from "@/api/org-api";

//查询条件
const queryCon = reactive({ devNo: "", devModelId: null, devBatchNo: "", pageSize: 10, currentPage: 1 });

//表单对象
const form = reactive({
    id: "",
    devNo: "",
    devModelId: null,
    evBatchNo: "",
    devOnlineStatus: 0,
    iccid: "",
    imei: "",
    devStatus: null,
    orgId: null
});

const OrgOptions = ref([]);

const defaultProps = {
    children: "children",
    label: "orgName",
};

const rules = {
    devNo: [{ required: true, message: "", trigger: "blur" }],
    devModelId: [{ required: true, message: "", trigger: "blur" }],
    devBatchNo: [{ required: true, message: "", trigger: "blur" }],
};

//分页处理
const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100],
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    },
};

//弹出框状态
const dialogFormVisible = ref(false);
const tableLoading = ref(false);
//引用
const tableData = ref([]);
const dataTableRef = ref(null);
const dataFormRef = ref(null);
const deviceModels = ref([]);
const importDialogVisible = ref(false);
const uploadRef = ref(null);
const importForm = reactive({
    devModelId: null,
    devBatchNo: "",
    file: null,
});

async function init() {
    //加载机构
    const orgTreeData = await orgApi.loadOrgOptions();
    OrgOptions.value = orgTreeData || [];
    //加载型号
    const { data } = await deviceModelApi.queryList();
    console.log(data.result);
    deviceModels.value = data.result || [];
}

//生命周期
onMounted(async () => {
    await init();
    handler.queryHandler();
});

const resetForm = () => {
    dataFormRef.value?.resetFields();
};

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        deviceApi
            .query(queryCon)
            .then((response) => {
                if (response.data.errorCode === "00000") {
                    tableData.value = response.data.result.records;
                    pagination.pageInfo.total = response.data.result.total;
                } else {
                    ElMessage.error(
                        sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode)
                    );
                }
            })
            .finally(function () {
                tableLoading.value = false;
            });
    },
    reset() {
        queryCon.devNo = "";
        queryCon.devModelId = null;
        queryCon.devBatchNo = "";
        queryCon.currentPage = 1;
        handler.queryHandler();
    },
    addHandler() {
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        });
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm("确认要删除吗?", "Warning", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            deviceApi.delete([rowObj.id]).then((response) => {
                if (response.data.errorCode === "00000") {
                    ElMessage({ message: "删除成功.", type: "success" });
                    handler.queryHandler();
                    this.dialogFormVisible = false;
                } else {
                    ElMessage.error(
                        sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode)
                    );
                }
            });
        });
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) {
            ElMessage("没有选中任何行");
            return;
        }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm("确认要删除吗?", "Warning", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            deviceApi.delete(ids).then((response) => {
                if (response.data.errorCode === "00000") {
                    ElMessage({ message: "删除成功.", type: "success" });
                    handler.queryHandler();
                    this.dialogFormVisible = false;
                } else {
                    ElMessage.error(
                        sprintf("系统异常[ ErrorCode:%s ]", response.data.errorCode)
                    );
                }
            });
        });
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                deviceApi.save(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: "保存成功", type: "success" });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(
                            "系统出错[errorCode:" + response.data.errorCode + "]"
                        );
                    }
                }).catch((e)=>{
                    console.log(e);
                });
            }
        });
    },
    openImportHandler() {
        importForm.devModelId = null;
        importForm.devBatchNo = "";
        importForm.file = null;
        uploadRef.value?.clearFiles();
        importDialogVisible.value = true;
    },
    onImportFileChange(uploadFile) {
        importForm.file = uploadFile.raw || null;
    },
    onImportFileRemove() {
        importForm.file = null;
    },
    importHandler() {
        if (!importForm.devModelId) {
            ElMessage.error("请选择设备型号");
            return;
        }
        if (!importForm.devBatchNo) {
            ElMessage.error("请输入批次号");
            return;
        }
        if (!importForm.file) {
            ElMessage.error("请选择要导入的Excel文件");
            return;
        }
        const formData = new FormData();
        formData.append("file", importForm.file);
        formData.append("devModelId", importForm.devModelId);
        formData.append("devBatchNo", importForm.devBatchNo);
        deviceApi.importDevices(formData).then((response) => {
            if (response.data.errorCode === "00000") {
                const r = response.data.result;
                ElMessage.success(sprintf("导入完成：共%d条，成功%d条，跳过%d条", r.total, r.success, r.skipped));
                importDialogVisible.value = false;
                handler.queryHandler();
            } else {
                ElMessage.error(sprintf("导入失败[ ErrorCode:%s ]", response.data.errorCode));
            }
        });
    },
};
</script>
